$(document).ready(function() {
  //Init slideshow on homepage
  if($("[data-js-slideshow]").length > 0){
    var chk_number_dot = $("[data-js-slideshow]").data("numberondot");
    if(chk_number_dot == true ){
      $("[data-js-slideshow]").not('.slick-initialized').slick({   
        lazyLoad: 'ondemand',
        customPaging : function(slider, i) {   
            var thumb = $(slider.$slides[i]).data();
            var index = i+1;
            if(index<10){
              var str_index = "0"+index;
            }else{
              var str_index = index;
            }
            return '<a class="dot">'+str_index+'</a>';        

        },
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              arrows: false,
              centerMode: false,
              centerPadding: '0px',
              slidesToShow: 1
            }
          },
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '0px',
              slidesToShow: 1
            }
          },
          {
            breakpoint: 767,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '0px',
              slidesToShow: 1
            }
          },
          {
            breakpoint: 575,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '0px',
              slidesToShow: 1
            }
          } 
        ]
      }); 
    }else{
      $("[data-js-slideshow]").not('.slick-initialized').slick({   
        lazyLoad: 'ondemand',       
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              arrows: false,
              centerMode: false,
              centerPadding: '0px',
              slidesToShow: 1
            }
          },
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '0px',
              slidesToShow: 1
            }
          },
          {
            breakpoint: 767,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '0px',
              slidesToShow: 1
            }
          },
          {
            breakpoint: 575,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '0px',
              slidesToShow: 1
            }
          } 
        ]
      });
    }

    $("[data-js-slideshow]").show();
  }  
  function getSliderSettings() {
    return {
      dots: true,
      arrows: false,
      slidesToShow: 1,                  
      variableWidth: false,
      speed: 800,
      fade: true,

      responsive: [
        {
          breakpoint: 1200,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '0px',
            slidesToShow: 1
          }
        },
        {
          breakpoint: 992,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '0px',
            slidesToShow: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '0px',
            slidesToShow: 1
          }
        },
        {
          breakpoint: 575,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '0px',
            slidesToShow: 1
          }
        } 
      ]
    }
  }
  $(document).on('shopify:section:load', function(){  
    if($("[data-js-slideshow]").length > 0){
      $('[data-js-slideshow]').not('.slick-initialized').slick();
      $("[data-js-slideshow]").show();
    }
  });
  $(".slider .wrapper_caption").on("mousedown",function(){        
    $(this).attr("draggable","true");
  })
  $(".slider .wrapper_caption").on("mouseup",function(){        
    $(this).attr("draggable","false");
  })
  
  
  /* Thêm hiệu ưng cho text trong slider */   
  if ($("div[data-slider]").hasClass('slick-current') ){   
    var effect_sub_heading  = $("div[data-slider].slick-current").find(".slide_item_h4").data("animate");
    var effect_heading  = $("div[data-slider].slick-current").find(".slide_item_h3").data("animate");
    var effect_button  = $("div[data-slider].slick-current").find(".buttons").data("animate");
    var effect_txt  = $("div[data-slider].slick-current").find(".slide_item_p").data("animate");
    
    $("div[data-slider].slick-current").find(".slide_item_h4").addClass("animated");
    $("div[data-slider].slick-current").find(".slide_item_h4").addClass(effect_sub_heading);   
    // Thêm animate cho heading
    $("div[data-slider].slick-current").find(".slide_item_h3").addClass("animated");
    $("div[data-slider].slick-current").find(".slide_item_h3").addClass(effect_heading);  
    // Thêm animate cho button
    $("div[data-slider].slick-current").find(".buttons").addClass("animated");
    $("div[data-slider].slick-current").find(".buttons").addClass(effect_button);  
    // Thêm animate cho text
    $("div[data-slider].slick-current").find(".slide_item_p").addClass("animated");
    $("div[data-slider].slick-current").find(".slide_item_p").addClass(effect_txt);   
  }  
  
  /* Trước khi thay đổi slide */
  $('[data-js-slideshow]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      var effect_sub_heading  = $("div[data-slider].slick-current").find(".slide_item_h4").data("animate");
	  var effect_heading  = $("div[data-slider].slick-current").find(".slide_item_h3").data("animate");
      var effect_button  = $("div[data-slider].slick-current").find(".buttons").data("animate");
      var effect_txt  = $("div[data-slider].slick-current").find(".slide_item_p").data("animate");
    
      $("div[data-slider].slick-slide").find(".slide_item_h4").removeClass("animated");  
      $("div[data-slider].slick-slide").find(".slide_item_h4").removeClass(effect_sub_heading);
      // Xoá animate cho heading
      $("div[data-slider].slick-slide").find(".slide_item_h3").removeClass("animated");
      $("div[data-slider].slick-slide").find(".slide_item_h3").removeClass(effect_heading);
      // Xoá animate cho button
      $("div[data-slider].slick-slide").find(".buttons").removeClass("animated");
      $("div[data-slider].slick-slide").find(".buttons").removeClass(effect_button);
      // Xoá animate cho text
      $("div[data-slider].slick-slide").find(".slide_item_p").removeClass("animated");
      $("div[data-slider].slick-slide").find(".slide_item_p").removeClass(effect_txt);
  })
  /* Sau khi thay đổi slide */
  $('[data-js-slideshow]').on('afterChange', function(event, slick, currentSlide){
    if ($("div[data-slider]").hasClass('slick-active')){
      var effect_sub_heading  = $("div[data-slider].slick-current").find("h4").data("animate");      
      var effect_heading  = $("div[data-slider].slick-current").find(".slide_item_h3").data("animate");
      var effect_button  = $("div[data-slider].slick-current").find(".buttons").data("animate");
      var effect_txt  = $("div[data-slider].slick-current").find(".slide_item_p").data("animate");
      
      $("div[data-slider].slick-current").find(".slide_item_h4").addClass("animated");
      $("div[data-slider].slick-current").find(".slide_item_h4").addClass(effect_sub_heading);     
      // Thêm animate cho heading
      $("div[data-slider].slick-current").find(".slide_item_h3").addClass("animated");
      $("div[data-slider].slick-current").find(".slide_item_h3").addClass(effect_heading);    
      // Thêm animate cho button
      $("div[data-slider].slick-current").find(".buttons").addClass("animated");
      $("div[data-slider].slick-current").find(".buttons").addClass(effect_button);   
      // Thêm animate cho text
      $("div[data-slider].slick-current").find(".slide_item_p").addClass("animated");
      $("div[data-slider].slick-current").find(".slide_item_p").addClass(effect_txt);   
    }
  });
})